import { Theme } from '@radix-ui/themes';
import '@radix-ui/themes/styles.css';
import '@digiseg-labs/design-system/styles.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/index.css';
import { BrowserRouter } from 'react-router-dom';
import './styles/ai_style.css';

const rootdiv = document.getElementById('root') as HTMLElement;
const modeFromAttribute = rootdiv.getAttribute('data-mode');

const root = ReactDOM.createRoot(
  rootdiv
);

root.render(
  <React.StrictMode>
    <Theme>
      <BrowserRouter>
        <App fallbackMode={modeFromAttribute || 'prompt'} />
      </BrowserRouter>
    </Theme>
  </React.StrictMode>
);

reportWebVitals();
